/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The MonitoringControllerDtoNftBoxListRequest model module.
 * @module model/MonitoringControllerDtoNftBoxListRequest
 * @version 1.0
 */
class MonitoringControllerDtoNftBoxListRequest {
    /**
     * Constructs a new <code>MonitoringControllerDtoNftBoxListRequest</code>.
     * @alias module:model/MonitoringControllerDtoNftBoxListRequest
     * @param page {Number} 
     * @param pageLength {Number} 
     */
    constructor(page, pageLength) { 
        
        MonitoringControllerDtoNftBoxListRequest.initialize(this, page, pageLength);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, page, pageLength) { 
        obj['page'] = page;
        obj['pageLength'] = pageLength;
    }

    /**
     * Constructs a <code>MonitoringControllerDtoNftBoxListRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/MonitoringControllerDtoNftBoxListRequest} obj Optional instance to populate.
     * @return {module:model/MonitoringControllerDtoNftBoxListRequest} The populated <code>MonitoringControllerDtoNftBoxListRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new MonitoringControllerDtoNftBoxListRequest();

            if (data.hasOwnProperty('page')) {
                obj['page'] = ApiClient.convertToType(data['page'], 'Number');
            }
            if (data.hasOwnProperty('pageLength')) {
                obj['pageLength'] = ApiClient.convertToType(data['pageLength'], 'Number');
            }
            if (data.hasOwnProperty('skip')) {
                obj['skip'] = ApiClient.convertToType(data['skip'], 'Number');
            }
            if (data.hasOwnProperty('account')) {
                obj['account'] = ApiClient.convertToType(data['account'], 'String');
            }
            if (data.hasOwnProperty('nftUid')) {
                obj['nftUid'] = ApiClient.convertToType(data['nftUid'], 'Number');
            }
            if (data.hasOwnProperty('grade')) {
                obj['grade'] = ApiClient.convertToType(data['grade'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>MonitoringControllerDtoNftBoxListRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>MonitoringControllerDtoNftBoxListRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of MonitoringControllerDtoNftBoxListRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['account'] && !(typeof data['account'] === 'string' || data['account'] instanceof String)) {
            throw new Error("Expected the field `account` to be a primitive type in the JSON string but got " + data['account']);
        }
        // ensure the json data is a string
        if (data['grade'] && !(typeof data['grade'] === 'string' || data['grade'] instanceof String)) {
            throw new Error("Expected the field `grade` to be a primitive type in the JSON string but got " + data['grade']);
        }

        return true;
    }


}

MonitoringControllerDtoNftBoxListRequest.RequiredProperties = ["page", "pageLength"];

/**
 * @member {Number} page
 */
MonitoringControllerDtoNftBoxListRequest.prototype['page'] = undefined;

/**
 * @member {Number} pageLength
 */
MonitoringControllerDtoNftBoxListRequest.prototype['pageLength'] = undefined;

/**
 * @member {Number} skip
 */
MonitoringControllerDtoNftBoxListRequest.prototype['skip'] = undefined;

/**
 * @member {String} account
 */
MonitoringControllerDtoNftBoxListRequest.prototype['account'] = undefined;

/**
 * @member {Number} nftUid
 */
MonitoringControllerDtoNftBoxListRequest.prototype['nftUid'] = undefined;

/**
 * @member {String} grade
 */
MonitoringControllerDtoNftBoxListRequest.prototype['grade'] = undefined;






export default MonitoringControllerDtoNftBoxListRequest;

